import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpBaseService } from "./services/httpBase.service";
import { HttpServer } from "./services/sie.httpBase";
import { HttpClientModule } from "@angular/common/http";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";

import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { MainComponent } from "./main/main.component";
import { HeaderComponent } from "./header/header.component";
import { SliderComponent } from "./slider/slider.component";
import { CheckRouteService, LoginService } from "./PermissionGuard";
import { DropDownComponent } from "./drop-down/drop-down.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { TabName, News, News2 } from "./class";
import { ScanCodeComponent } from './scan-code/scan-code.component';
import { NewsListComponent } from './news-list/news-list.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { SearchFormComponent } from './search-form/search-form.component';
import { GoLinkDirective } from './directives/go-link.directive';
import {NZ_NOTIFICATION_CONFIG } from 'ng-zorro-antd';
import { NotificationComponent } from './components/notification/notification.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MainComponent,
    HeaderComponent,
    SliderComponent,
    DropDownComponent,
    NotFoundComponent,
    ScanCodeComponent,
    NewsListComponent,
    NewsDetailComponent,
    SearchFormComponent,
    GoLinkDirective,
    NotificationComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule.forRoot()
  ],
  providers: [
    HttpBaseService,
    HttpServer,
    CheckRouteService,
    LoginService,
    TabName,
    News,
    News2,
    { provide: NZ_NOTIFICATION_CONFIG, useValue: {nzPlacement: 'bottomRight'}},
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/app.module.ts